module.exports = __webpack_public_path__ + "img/bgg icon.05d91cb3.svg";